import 'intersection-observer';
import domReady from '../helpers/dom-ready';

export default class InView {
  static init() {
    return new InView();
  }

  constructor() {
    this.items = [...document.querySelectorAll('.js-in-view')];

    this.load();
  }

  show(element) {
    element.classList.add('-in-view');
  }

  load() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // in view
          if (entry.intersectionRatio > 0) {
            this.show(entry.target);

            observer.unobserve(entry.target);
          }
        });
      },
      {
        // threshold: 0, // [0, 0.25, 0.5, 1],
        // rootMargin: '0px 0px -200px 0px',
        threshold: [0.0, 0.25], // [0, 0.25, 0.5, 1],
        rootMargin: '0px 0px -15% 0px',
      },
    );

    for (let i = 0; i < this.items.length; i += 1) {
      const item = this.items[i];

      if (i === 0) {
        // Assume first section is in view
        // (to make parallax and IntersectionObserver work in Safari)
        const firstSection = item;
        setTimeout(() => {
          this.show(firstSection);
          const children = firstSection.querySelectorAll('.js-in-view');
          if (children.length > 0) {
            [...children].forEach((child) => {
              this.show(child);
            });
          }
        }, 200);
      } else {
        observer.observe(item);
      }
    }
  }
}

domReady(() => {
  InView.init();
});
